'use client';

import { ImageLoaderProps } from 'next/image';

const CACHE_BUST = '12-11-2025';

const imageLoader = ({ src, width, quality = 90 }: ImageLoaderProps) => {
  if (!src) return src;

  const directusApiUri = `${process.env.NEXT_PUBLIC_DIRECTUS_NC_API_URL}/assets`;

  const url = new URL(src);

  const urlParams = url.searchParams;

  const desktopImage = urlParams.get('__dis');

  const mobileImage = urlParams.get('__mis');

  let imageToDisplay = desktopImage;

  if (width <= 575) {
    imageToDisplay = mobileImage;
    width = 575;
  }

  let imageKey = `image-q${quality}-w${width}`;

  const srcUrl = `${directusApiUri}/${imageToDisplay}?key=${imageKey}&_requested_width=${width}&${CACHE_BUST}`;

  return `${srcUrl}`;
};

export default imageLoader;
